import makeHttpRequest from '../helpers/ajax';

const getReviewsURL = () => {
    return WP_REVIEWS_URL;
};

const getReviewsAPIKey = () => {
    return WP_REVIEWS_APIKEY;
};

const getLenderReviewInfo = (lenderId, contentIdForReviews, callBackFunction) => {
    const errorResponse = {};
    let url = getReviewsURL();
    url += `reviews?productType=&requestmode=reviews,stats,ratingconfig,propertyconfig&passkey=${getReviewsAPIKey()}&brandId=${contentIdForReviews}&pageSize=${3}`;
    const request = { url, storage_key: `${lenderId}_reviews${contentIdForReviews}_productId` };
    return makeHttpRequest(request).then((response) => {
        const lenderReviewResponse = JSON.parse(response);
        if (callBackFunction) {
            callBackFunction(lenderReviewResponse.result);
        }
    }, (error) => {
        console.warn(`There is some issue with network call for lender reviews, please try again ${error}`);
        return errorResponse;
    });
};

const getRequestObject = (contentIdForReviews, lenderId) => {
    let url = getReviewsURL();
    url += `reviews?productType=&requestmode=stats,ratingconfig,propertyconfig&passkey=${getReviewsAPIKey()}&brandId=${contentIdForReviews}&pageSize=${3}`;
    const request = { url, storage_key: `${lenderId}_reviews${contentIdForReviews}_productId` };
    return request;
};

const getRefinaceLenderReviewInfo = (lenderId, contentIdForReviews) => {
    const errorResponse = {};
    const request = getRequestObject(contentIdForReviews, lenderId);
    return makeHttpRequest(request).then((response) => {
        const lenderReviewResponse = JSON.parse(response);
        return lenderReviewResponse.result;
    }, (error) => {
        console.warn(`There is some issue with network call for lender reviews, please try again ${error}`);
        return errorResponse;
    });
};
const getLenderStatisticsInfo = (lenderId, contentIdForReviews, callBackFunction) => {
    const errorResponse = {};
    const request = getRequestObject(contentIdForReviews, lenderId);
    return makeHttpRequest(request).then((response) => {
        const lenderStatisticsResponse = JSON.parse(response);
        if (callBackFunction) {
            callBackFunction(lenderStatisticsResponse.result);
        }
    }, (error) => {
        console.warn(`There is some issue with network call for lender reviews, please try again ${error}`);
        return errorResponse;
    });
};

export { getLenderReviewInfo, getRefinaceLenderReviewInfo, getLenderStatisticsInfo };
